import backofficeService from '../../api/backoffice'

export default {  
  findMatch(params) {
    return backofficeService.Api().get('profile/match', { params })
      .then(response => response.data)
      .catch(error =>{ throw error})
  },
}
